module.exports = __webpack_public_path__ + "img/rose.7f1fc154.svg";